import styled, { css } from "styled-components";

export const Section = styled.div`
  box-shadow: 0 0 0.7rem 0.5rem rgb(0 0 0 / 0.1);
  margin: 3rem 0;
  padding: 2rem;
  border-radius: 0.5rem;
`;

export const SubSection = styled.div`
  padding: 1rem 0;
`;

export const SectionTitle = styled.h3`
  margin: 0.5rem 0 2rem 0;
  font-weight: 600;
`;

export const SectionSubTitle = styled.h4`
  margin: 0;
  font-weight: 600;
`;

export const autoCompleteCustomStyles = css`
  background-color: ${({ theme }) => theme.colors.lightgrey};
  color: ${({ theme }) => theme.colors.darkblue};
  width: 50%;
  border-radius: 0.5rem;
`;

export const WarningSection = styled(Section)`
  border: 0.1rem solid ${({ theme }) => theme.colors.orangeWarning};
`;
